/**
 * cookiebar
 */

import 'cookieconsent';
/* eslint-disable */
const cookiebar = {
    cfg: {
        text: 'Wir verwenden Cookies um Ihnen die beste Erfahrung auf unserer Website bieten zu können.' ,
        link: 'Mehr erfahren..',
        dismiss: 'Verstanden',
        href: '/datenschutz',
    },
    init() {
        window.addEventListener('load', () => {
            window.cookieconsent.initialise({
                theme: 'classic',
                position: 'bottom-right',
               
                content: {
                    message: this.cfg.text,
                    dismiss: `&rarr;  ${this.cfg.dismiss}`,
                    link: `${this.cfg.link}`,
                    href: this.cfg.href,
                }
            });
        });
    }
};
/* eslint-enable */
export default cookiebar;



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/cookiebar.js